export default __webpack_public_path__ + "static/media/donegal-airport.4c008176.jpeg";